/**
 * GA4 커스텀 이벤트 — gtag('event', ...)
 * @see app/layout.tsx gtag 초기화
 */

/** GA4 `blog_cta_click` 매개변수 `cta_name` 값 */
export type TBlogCtaAnalyticsName = 'start_free_trial' | 'compare_pricing' | 'email_demo';

/** 디버깅·확장용 이벤트 이름 묶음 (스키마 변경 시 참고용) */
export const GA4_EVENT_NAMES = {
  blogCtaClick: 'blog_cta_click',
  faqOpen: 'faq_open',
  relatedArticleClick: 'related_article_click',
  pricingCardClick: 'pricing_card_click',
} as const;

/** 범용: 후속 이벤트(faq_open 등) 재사용 (실패 시 no-op → mailto/링크 이동은 방해하지 않음) */
export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean | undefined>,
): void {
  try {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
      return;
    }

    const clean = params
      ? Object.fromEntries(
          Object.entries(params).filter(([, v]) => v !== undefined) as [
            string,
            string | number | boolean,
          ][],
        )
      : undefined;

    window.gtag('event', eventName, clean ?? {});
  } catch {
    /* ignore */
  }
}

export function trackBlogCtaClick(payload: {
  cta_name: TBlogCtaAnalyticsName;
  /** 블로그 포스트 슬래그 문자열 예: `tindlo-vs-competitors-2026` */
  page: string;
  /** 배치 예: bottom_cta, decision_framework_mid */
  section: string;
}): void {
  trackEvent(GA4_EVENT_NAMES.blogCtaClick, {
    cta_name: payload.cta_name,
    page: payload.page,
    section: payload.section,
  });
}
